import React from 'react';
import { store } from 'store';

import AccessDenied from './AccessDenied';

const Empty = () => <></>;

const withRole = (role, Component, returnNull) => {
  const { roles } = store.getState().Auth.user;

  if (!roles.includes(role)) {
    if (returnNull === true) {
      return Empty;
    }
    return AccessDenied;
  }

  return Component;
};

export default withRole;
